import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { BoolToLabelPipe } from "./bool-to-label.pipe";
import { AppCurrencyPipe } from "./app-currency.pipe";
import { AppDatePipe } from "./app-date.pipe";
import { TrimPipe } from "./trim.pipe";
import { TicketStatusPipe } from "./ticket-status.pipe";
import { LogTypePipe } from "./log-type.pipe";
import { OperatorTypePipe } from "./operator-type.pipe";
import { TransactionTypePipe } from "./transaction-type.pipe";
import { AppNotePipe } from "./app-note.pipe";
import { CommissionPartyRolePipe } from "./commission-party-role.pipe";
import { AtmPartnerModelPipe } from "./atm-partner-model.pipe";
import { CommissionRateTypePipe } from "./commission-rate-type.pipe";
import { AssetClassPipe } from "./asset-class.pipe";
import { NotificationTypePipe } from "./notification-type.pipe";
import { AtmHealthStatusPipe } from "./atm-health-status.pipe";
import { AtmFunctionTypePipe } from "./atm-function-type.pipe";
import { JsonPrettyPipe } from "./json-pretty.pipe";

const PIPES = [
  NotificationTypePipe,
  AtmHealthStatusPipe,
  AtmFunctionTypePipe,
  JsonPrettyPipe,
  BoolToLabelPipe,
  AppCurrencyPipe,
  AppDatePipe,
  TrimPipe,
  TicketStatusPipe,
  LogTypePipe,
  OperatorTypePipe,
  TransactionTypePipe,
  AppNotePipe,
  CommissionPartyRolePipe,
  AtmPartnerModelPipe,
  CommissionRateTypePipe,
  AssetClassPipe,
];

@NgModule({
  declarations: PIPES,
  exports: PIPES,
  imports: [CommonModule],
  providers: [DatePipe],
})
export class PipesModule {}
